var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 263 263",
    style: {
      enableBackground: "new 0 0 263 263"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#D2AB67;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D2AB67;}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 136.8718,
    cy: 105.9946,
    r: 123.6794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1052,
    style: {
      stopColor: "#DE1A22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3187,
    style: {
      stopColor: "#CB171E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    style: {
      stopColor: "#BC141A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    style: {
      stopColor: "#B41217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B11116"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 263,
    height: 263
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.7,106.1c0-4.5-3.6-8.1-8.1-8.1c-4.5,0-8.1,3.6-8.1,8.1c0,2.9,1.5,5.4,3.7,6.8l-3.4,26.9h16l-3.6-27 C143.3,111.4,144.7,108.9,144.7,106.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.6,95.1c-1.1-3.7-4.9-4.7-4.9-8.2c0-3.5,3.8-4.5,4.9-8.2c1.1,3.7,4.9,4.7,4.9,8.2 C141.5,90.5,137.7,91.4,136.6,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.6,77.1c-1.3-4.4-5.8-5.5-5.8-9.6c0-4.1,4.4-5.2,5.8-9.6c1.3,4.4,5.8,5.5,5.8,9.6 C142.3,71.6,137.9,72.7,136.6,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.9,112.7c2.3-0.6,4,1.1,5.8,0c1.8-1.1,1.2-3.4,2.7-5.1c-2.3,0.6-4-1.1-5.8,0 C105.8,108.7,106.4,111,104.9,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,100.1c3.1,1.8,3.2,5.5,6.3,6.2c3.2,0.8,4.9-2.5,8.5-2.7c-3.1-1.8-3.2-5.5-6.3-6.2 C100.6,96.6,99,99.8,95.3,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.7,87.6c-1.6-3.8,0.9-7.1-1.5-10c-2.4-2.9-6.1-1.1-9.5-3.4c1.6,3.8-0.9,7.1,1.5,10 C107.5,87.1,111.2,85.3,114.7,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.3,93.2c-2.3-2.2-1.6-5.4-4.2-6.7c-2.6-1.3-4.7,1.2-7.9,0.6c2.3,2.2,1.6,5.4,4.2,6.7 C101,95.1,103.1,92.6,106.3,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.7,77.4c-0.3-4.1,3.1-6.5,1.7-10c-1.4-3.5-5.5-2.9-8-6.2c0.3,4.1-3.1,6.5-1.7,10 C113,74.7,117.1,74.2,119.7,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126,66.3c0.4-3.1,3.3-4.3,2.8-7c-0.4-2.7-3.5-3-4.9-5.8c-0.4,3.1-3.3,4.3-2.8,7 C121.6,63.3,124.7,63.5,126,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.3,72.2c-0.9-1.8,0.2-3.5-1-4.8c-1.2-1.3-3-0.4-4.7-1.4c0.9,1.8-0.2,3.5,1,4.8 C105.8,72.2,107.6,71.2,109.3,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.8,82.6c-1.2-1.6-0.4-3.4-1.9-4.5c-1.4-1.1-3,0.2-4.9-0.4c1.2,1.6,0.4,3.4,1.9,4.5 C98.3,83.2,99.9,81.9,101.8,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.9,85.4c0.4-3.9,4-5.6,3.3-9.1c-0.7-3.5-4.6-3.7-6.5-7.2c-0.4,3.9-4,5.6-3.3,9.1 C123.1,81.7,127.1,82,128.9,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.1,95.7c-1.1-3.7,1.6-6.6-0.4-9.5c-1.9-2.9-5.6-1.6-8.5-4.1c1.1,3.7-1.6,6.6,0.4,9.5 C119.5,94.5,123.1,93.3,126.1,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.9,104.5c-2.5,1.6-5.1,0.3-6.9,2.3c-1.7,2,0,4.4-1.1,7.2c2.5-1.6,5.1-0.3,6.9-2.3 C124.5,109.6,122.7,107.2,123.9,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.6,56.9c-0.6-1.9-2.6-2.3-2.6-4.1c0-1.8,1.9-2.3,2.4-4.2c0.6,1.9,2.6,2.3,2.6,4.1 C139.1,54.4,137.2,55,136.6,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.8,95c3.4,0.6,5.7-1.9,8.5-0.5c2.8,1.5,1.9,4.8,4.4,7.3c-3.4-0.6-5.7,1.9-8.5,0.5 C110.4,100.8,111.2,97.4,108.8,95z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.2,112.7c-2.3-0.6-4,1.1-5.8,0c-1.8-1.1-1.2-3.4-2.7-5.1c2.3,0.6,4-1.1,5.8,0 C167.3,108.7,166.6,111,168.2,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.7,100.1c-3.1,1.8-3.2,5.5-6.3,6.2c-3.2,0.8-4.9-2.5-8.5-2.7c3.1-1.8,3.2-5.5,6.3-6.2 C172.5,96.6,174.1,99.8,177.7,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.4,87.6c1.6-3.8-0.9-7.1,1.5-10c2.4-2.9,6.1-1.1,9.5-3.4c-1.6,3.8,0.9,7.1-1.5,10 C165.6,87.1,161.8,85.3,158.4,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.8,93.2c2.3-2.2,1.6-5.4,4.2-6.7c2.6-1.3,4.7,1.2,7.9,0.6c-2.3,2.2-1.6,5.4-4.2,6.7 C172,95.1,170,92.6,166.8,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.4,77.4c0.3-4.1-3.1-6.5-1.7-10c1.4-3.5,5.5-2.9,8-6.2c-0.3,4.1,3.1,6.5,1.7,10 C160,74.7,155.9,74.2,153.4,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147,66.3c-0.4-3.1-3.3-4.3-2.8-7c0.4-2.7,3.5-3,4.9-5.8c0.4,3.1,3.3,4.3,2.8,7 C151.5,63.3,148.4,63.5,147,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.8,72.2c0.9-1.8-0.2-3.5,1-4.8c1.2-1.3,3-0.4,4.7-1.4c-0.9,1.8,0.2,3.5-1,4.8 C167.3,72.2,165.5,71.2,163.8,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.3,82.6c1.2-1.6,0.4-3.4,1.9-4.5c1.4-1.1,3,0.2,4.9-0.4c-1.2,1.6-0.4,3.4-1.9,4.5 C174.7,83.2,173.2,81.9,171.3,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.2,85.4c-0.4-3.9-4-5.6-3.3-9.1c0.7-3.5,4.6-3.7,6.5-7.2c0.4,3.9,4,5.6,3.3,9.1 C149.9,81.7,146,82,144.2,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147,95.7c1.1-3.7-1.6-6.6,0.4-9.5c1.9-2.9,5.6-1.6,8.5-4.1c-1.1,3.7,1.6,6.6-0.4,9.5 C153.6,94.5,149.9,93.3,147,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.2,104.5c2.5,1.6,5.1,0.3,6.9,2.3c1.7,2,0,4.4,1.1,7.2c-2.5-1.6-5.1-0.3-6.9-2.3 C148.6,109.6,150.4,107.2,149.2,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.2,94.8c-3.4,0.7-5.8-1.8-8.5-0.2c-2.7,1.5-1.8,4.9-4.2,7.4c3.4-0.7,5.8,1.8,8.5,0.2 C162.7,100.6,161.8,97.3,164.2,94.8z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "172.1,174 172.1,183.7 194.6,183.7 194.6,190 164.1,190 164.1,152 194.6,152 194.6,158.3 172.1,158.3  172.1,167.9 194.6,167.9 194.6,174  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.4,161.3c-5-2.9-14.5-4.8-19.5-3.2c-1.1,0.4-2,0.9-2.7,1.7c-0.7,0.7-1,1.5-1,2.4c0,1.4,0.9,2.4,2.6,2.9 c0.9,0.3,2.8,0.5,5.7,0.8l4.4,0.4c2.6,0.3,4.7,0.7,6.3,1.1c1.6,0.5,3,1.2,4.3,2c1.3,0.9,2.3,2.1,3,3.6c0.7,1.5,1.1,3.1,1.1,4.8 c0,2.7-0.9,5.1-2.6,7.1c-1.6,1.9-4,3.3-7.3,4.2c-9.1,2.5-17.6,0-26.1-3.2l3.2-6.4c6.2,3.1,15.9,6.1,21.5,3c1-0.5,1.7-1.1,2.3-1.9 c0.6-0.8,0.9-1.6,0.9-2.4c0-1.3-0.7-2.2-2-2.7c-0.9-0.4-2.9-0.7-5.7-1l-4.3-0.4c-2.9-0.3-4.9-0.6-6.1-0.8c-1.2-0.3-2.4-0.7-3.6-1.3 c-1.7-0.8-3-2.1-4-3.8c-0.9-1.5-1.3-3.2-1.3-5.2c0-3.2,1.1-5.9,3.3-8c2.9-2.8,7.2-4.1,13-4.1c6.1,0,11.8,1.8,17.6,3.9L109.4,161.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.1,174.3l-6.2-12.8l-6.3,12.8H54.1z M56.5,180.3H39.2l-0.3,0.7l-0.1,0l-4.1,9h-8.2l1.1-2.2 c0.3-0.4,0.6-1,0.9-1.7l9.7-20.2l6.7-13.9h7c6.2,12.7,12.3,25.3,18.5,38H61c-1.2-2.6-2.2-5-3.4-7.5l-0.6-1.4l0,0L56.5,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.6,161.3c-5-2.9-14.5-4.8-19.5-3.2c-1.1,0.4-2,0.9-2.7,1.7c-0.7,0.7-1,1.5-1,2.4c0,1.4,0.9,2.4,2.6,2.9 c0.9,0.3,2.8,0.5,5.7,0.8l4.4,0.4c2.6,0.3,4.7,0.7,6.3,1.1c1.6,0.5,3,1.2,4.3,2c1.3,0.9,2.3,2.1,3,3.6c0.7,1.5,1.1,3.1,1.1,4.8 c0,2.7-0.9,5.1-2.6,7.1c-1.6,1.9-4,3.3-7.3,4.2c-9.1,2.5-17.6,0-26.1-3.2l3.2-6.4c6.2,3.1,15.9,6.1,21.5,3c1-0.5,1.7-1.1,2.3-1.9 c0.6-0.8,0.9-1.6,0.9-2.4c0-1.3-0.7-2.2-2-2.7c-0.9-0.4-2.9-0.7-5.7-1l-4.3-0.4c-2.9-0.3-4.9-0.6-6.1-0.8c-1.2-0.3-2.4-0.7-3.6-1.3 c-1.7-0.8-3-2.1-4-3.8c-0.9-1.5-1.3-3.2-1.3-5.2c0-3.2,1.1-5.9,3.3-8c2.9-2.8,7.2-4.1,13-4.1c6.1,0,11.8,1.8,17.6,3.9L152.6,161.3z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "223.8,158.3 223.8,190 215.5,190 215.5,158.3 201.8,158.3 201.8,152 236.5,152 236.5,158.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.f1918f533435a7ce54784ec9e5aab055.svg";
export { ForwardRef as ReactComponent };